import { Box, Button, IconButton, TextField, Tooltip,Chip } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	approveQuota,
	getGraphModalSkuPgData,
	getPopupGraphDataBySku,
	getQuotaCustomerBreakdown,
	getQuotaForApproval,
	lockUnlockQuota,
	rejectQuota,
	setState,
} from "./quotaSlice";

import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from '@mui/icons-material/Circle';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import EditIcon from '@mui/icons-material/Edit';
import SmsIcon from '@mui/icons-material/Sms';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setState as setDefineState, GetScenarioforQuotaDefinition, GetUserCountries, GetQuotaPeriodsfromNavigation, GetWeeklyDepletion, reset, navigatedValues } from "../../Define/defineSlice";
import './QuotaApproval.css';
import moment from "moment";
import { green, orange, red, grey, blue } from '@mui/material/colors';
import muiConfig from '../../../assets/MuiConfig.json'

function getQuotaForApprovalColumn(countries) {

	function getChipProps(params) {
		if (params.value === 1) {
			return {
				label: "Low",
				style: {
					fontWeight: 'bold',
					//borderColor: green[500],
					backgroundColor: green[50],
					color: green[500],
				},
			};
		}
	
		else if (params.value === 2) {
			return {
				label: "Medium",
				style: {
					fontWeight: 'bold',
					borderColor: orange[500],
					backgroundColor: orange[50],
					color: orange[500]
				},
			};
		}
	
		else if (params.value === 3) {
			return {
				label: "High",
				style: {
					fontWeight: 'bold',
					borderColor: red[500],
					backgroundColor: red[50],
					color: red[500]
				},
			};
		}
	
		else if (params.value === 4) {
			return {
				label: "Severe",
				style: {
					fontWeight: 'bold',
					borderColor: grey[700],
					backgroundColor: grey[100],
					color: grey[700]
				},
			};
		}
	
		else {
			return {
				label: "Other",
				style: {
					fontWeight: 'bold',
					borderColor: blue[500],
					backgroundColor: blue[50],
					color: blue[500]
				},
			};
		}
	}
	const w = 120;
	const columns = [
		{ field: "scenarioName", headerName: "Scenario", width: w + 50},
		{
			field: "geoId",
			headerName: "Country Code",
			width: w,
			align:"center",
			headerAlign:"center",
			valueGetter: (params) => {
				const country = countries.find(c => c.countryID === params.row.geoId);
				if (!country) {
					return "Not Found";
				}
				return country.countryCode;
			}
		},
		{
			field: "criticalityId",
			headerName: "Criticality",
			width: w,
			align:"center",
			headerAlign:"center",
			renderCell: (params) => {
				return <Chip sx={{ height: "1.8rem", minHeight : "1.8rem", padding: "0.5rem", }} {...getChipProps(params)} />;
			},
		},
		{
			field: "graph",
			headerName: "Graph",
			width: w,
			align:"center",
			headerAlign:"center",
			renderCell: ShowGraph
		},
		{ field: "quotaStatus", headerName: "Quota Status", width: w },
		{
			field: "initialForecast", headerName: "Initial Quota", width: w,align:"center",
			headerAlign:"center",
			valueFormatter: (params) => {
				const formattedValue = params.value?.toLocaleString('en-US');
				return formattedValue;
			}
		},
		{
			field: "totalForecast", headerName: "Total Quota", width: w,
			align:"center",
			headerAlign:"center",
			valueFormatter: (params) => {
				const formattedValue = params.value?.toLocaleString('en-US');
				return formattedValue;
			}
		},
		{ field: "revisedQuota", headerName: "Revised Quota", width: w+20, renderCell: RevisedQuota },
		{
			field: "previousTotalForecast",
			headerName: "Previous Total Quota",
			width: w+50,
			align:"center",
			headerAlign:"center",
			valueFormatter: (params) => {
				const formattedValue = params.value?.toLocaleString('en-US');
				return formattedValue;
			}
		},
		{
			field: "difference", headerName: "Diff %", width: w,
			align:"center",
			headerAlign:"center",
			valueFormatter: (params) => {
				const formattedValue = params.value?.toLocaleString('en-US');
				return formattedValue;
			}
		},
		// {
		// 	field: "depletion", headerName: "Depletion", width: w,align:"center",
		// 	headerAlign:"center", cellClassName: (params) => {
		// 		const currentRowIdx = params.id;
		// 		const Row = params.api.getRow(currentRowIdx);
		// 		const currentDepletion = params.value;
		// 		if (Row === undefined) return '';
		// 		if (Row.previousDepletion === "") return '';
		// 		const previousDepletion = Row.previousDepletion;
		// 		if (currentDepletion !== previousDepletion) {
		// 			return 'red-row';
		// 		}
		// 		return '';
		// 	}
		// },
		{
			field: "lastActionDate", 
			headerName: "Last Action Date", 
			width: w+20, 
            align:"center",
			headerAlign:"center",
			valueFormatter: (params) =>moment(params.value).format('DD/MM/YYYY')
		},
		{ field: "lastActionBy", headerName: "Last Action By", width: w+20,
			align:"center",
			headerAlign:"center", 
		},
		{
			field: "period", headerName: "Period", width: w,align:"center",
			headerAlign:"center",
			renderCell: (params) => (
				<div style={{ whiteSpace: 'normal' }}>
					{params.value}
				</div>
			),
		},
		{
			field: "reject",
			headerName: "Reject Quota",
			width: 124,
			align:"center",
			headerAlign:"center",
			renderCell: RejectButton,
		},
		{
			field: "approve",
			headerName: "Approve Quota",
			width: 130,
			align:"center",
			headerAlign:"center",
			renderCell: ApproveButton,
		},
		{
			field: "lockUnlock",
			headerName: "Lock / Unlock",
			width: w,
			align:"center",
			headerAlign:"center",
			renderCell: LockUnlock
		},
		{
			field: "edit",
			headerName: "Edit Quota",
			width: w,
			align:"center",
			headerAlign:"center",
			renderCell: EditQuota
		},
	];
	return columns;
}

export default function Table() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.quota);
	const { quotaForApprovalTable, countries, selectedRows } = state;
	const [isAll, setIsAll] = useState(false); 
	const [paginationModel, setPaginationModel] = useState({
		pageSize: 20,
		page: 0
	});

	const { rows } = quotaForApprovalTable;
	const columns = getQuotaForApprovalColumn(countries);
	const handleRowClick = (rowData) => {
		if (rowData != undefined) {
			const quotaId = rowData.row.quotaId;
			dispatch(getQuotaCustomerBreakdown({ quotaId }));
		}
		if (rowData.length === 0) {
			dispatch(setState("quotaCustomerBreakdown", null));
			dispatch(setState("quotaDetailsTable", null));
		}

	}
	const setModal = (newPaginationModel) => {
		if(newPaginationModel.pageSize === muiConfig.DataGrid_All && newPaginationModel.page === 0 && rows?.length > 100){
		setIsAll(true);
		}else{
		setIsAll(false);
		}
		setPaginationModel(newPaginationModel);  
	}

	return (
		<Box sx={{ mt: 3, maxWidth: "100%" }}>
			<DataGridPro style={{ overflow: 'auto' }} //maxHeight: 'calc(100vh - 130px)'
				rows={rows}
				columns={columns}
				onRowSelectionModelChange={(selRows) => {
					dispatch(setState("selectedRows", selRows));
					//    if(selRows.length > 0) {
					//       const quotaId = quotaForApprovalTable.rows[selRows[selRows.length - 1]].quotaId;
					//       dispatch(getQuotaCustomerBreakdown({ quotaId }));
					//    }
				}}
				// sx={{
				// 	'& .MuiDataGrid-cell': {
				// 	  whiteSpace: 'normal !important',
				// 	  wordWrap: 'break-word !important',
				// 	}}}
				sx={{
					...(!isAll ? {
						"& .MuiDataGrid-virtualScroller": {
						   maxHeight: "unset !important"
						}
					  } : {
						"& .MuiDataGrid-virtualScroller": {
						   maxHeight: "80vh !important"
						}
					})
				}}
				rowSelectionModel={selectedRows}
				isRowSelectable={(params) => params.row.canApproveReject === true}
				checkboxSelection
				disableRowSelectionOnClick
				disableColumnMenu
				getRowClassName={(params) =>
					params.row.canApproveReject !== true ? 'disabled-row' : ''
				}
				initialState={{
					pagination: { paginationModel: { pageSize:20, page:0 }}
				}}
				pagination
				pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}	
				paginationModel={paginationModel}
                onPaginationModelChange = {setModal}
				onRowClick={handleRowClick}
				headerHeight={40}
			/>
		</Box>
	);
}


function ShowGraph(params) {
	const dispatch = useDispatch();
	const countries = useSelector((store) => store.quota.countries);
	function getPopupData() {
		const country = countries.find((c) => c.countryID === params.row.geoId);
		const countryLabel =
			country?.countryName || country?.countryCode || "";
		dispatch(setState("graphModalScenarioName", params.row.scenarioName ?? ""));
		dispatch(setState("graphModalCountryName", countryLabel));
		dispatch(setState("graphModalScenarioId", params.row.scenarioId));
		dispatch(setState("graphModalSelectedProductIds", []));
		const obj = {
			scenarioID: params.row.scenarioId,
		};
		console.log("Approval_Quota_DetailsButton", obj);
		dispatch(getGraphModalSkuPgData(obj)).then((action) => {
			if (getGraphModalSkuPgData.fulfilled.match(action)) {
				const skuList = Array.isArray(action.payload) ? action.payload : [];
				const productIds = skuList
					.filter((item) => item?.packGroupOrSKUName !== "All")
					.map((item) => item.packGroupOrSKUID)
					.filter((id) => id != null && id !== "");
				dispatch(
					getPopupGraphDataBySku({
						scenarioID: obj.scenarioID,
						productIds,
					})
				);
			}
		});
		dispatch(setState("graphModalOpen", true));
	}

	return (
		<Button className="closeButton2" 
		style={{fontSize:"0.85rem"}}
		sx={{
			color: "#AD2A1C", 
			backgroundColor: "#F8E9E7",
			width: "80px !important", 
			height: "32px", 
			textTransform: "none",
			borderRadius: "4px", 
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			"&:hover": {
				backgroundColor: "#891515",
				color:"#FFFFFF" 
			},
		}}
		 onClick={(e) => {
			e.stopPropagation();
			getPopupData();
		}}>Details</Button>
	);
}


function Criticality(params) {

	const colors = [
		{ id: 5, color: "blue.main" },
		{ id: 4, color: "black.main" },
		{ id: 3, color: "red.main" },
		{ id: 2, color: "orange.main" },
		{ id: 1, color: "green.main" },
	];

	const CriticalityDesc = [
		{ id: 5, desc: "Other" },
		{ id: 4, desc: "Severe" },
		{ id: 3, desc: "High" },
		{ id: 2, desc: "Medium" },
		{ id: 1, desc: "Low" },
	]
	const Desc = CriticalityDesc.find(c => c.id === params.row.criticalityId).desc;
	const color = colors.find(c => c.id === params.row.criticalityId).color;
	return (
		<Box>
			<Tooltip title={Desc}>
				<CircleIcon sx={{ color: color }} />
			</Tooltip>
		</Box>
	);
}

function RejectButton(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const dispatch = useDispatch();
	function openRejectModal() {
		dispatch(setState("selectedQuotaid", params.row.quotaId));
		dispatch(setState("rejectSingleModalOpen", true));
	}

	if (params.row.canApproveReject && isRestrictedAccess) {
		return (
			<IconButton onClick={openRejectModal}>
				<CancelIcon sx={{ color: "red.main" }} />
			</IconButton>
		);
	}
	return null;
}

function ApproveButton(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const dispatch = useDispatch();
	const state = useSelector((store) => store.quota);
	const {
		quotaForApproval,
		selectedCountryID,
		selectedPeriod,
		selectedQuotaStatus,
		searchText
	} = state;

	function search() {
		dispatch(setState("quotaCustomerBreakdown", null));
		dispatch(setState("quotaDetailsTable", null));
		dispatch(setState("rejectSelectedComment", ''));
		dispatch(setState("selectedRows", []));
		const logedUser = JSON.parse(localStorage.getItem("data"));
		const countryId = selectedCountryID;
		const period = selectedPeriod;
		const quotaStatus = selectedQuotaStatus;

		const obj = {
			countryId,
			period,
			quotaStatus,
			logedUser,
			searchText: searchText
		};
		dispatch(getQuotaForApproval(obj));
	}

	function preparePayload() {
		const quota = quotaForApproval.find(
			(quota) => quota.quotaId === params.row.quotaId
		);
		console.log(quota);
		const user = JSON.parse(localStorage.getItem("data"));
		console.log(user);
		const obj = {
			...quota,
			user: user,
		};
		const country = user.userCountries.find(
			(index) => index.country.countryID === quota.geoId
		).country;
		console.log(country);

		return obj;
	}

	function approve() {
		const obj = preparePayload();
		dispatch(approveQuota(obj)).then(() => {
			search();
		});
	}

	function approvewithComments() {
		const obj = preparePayload();
		dispatch(setState("selectedQuotaid", obj.quotaId));
		dispatch(setState("approveSingleWithCommentsModalOpen", true));
	}

	if (params.row.canApproveReject && isRestrictedAccess) {
		return (
			<div>
				<IconButton onClick={approve}>
					<CheckCircleIcon sx={{ color: "green.main" }} />
				</IconButton>
				<IconButton onClick={approvewithComments}>
					<SmsIcon sx={{ color: "green.main" }} />
				</IconButton>
			</div>
		);
	}
	return null;
}

function LockUnlock(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const dispatch = useDispatch();
	const state = useSelector((store) => store.quota);
	const { quotaForApproval, selectedCountryID, selectedPeriod, selectedQuotaStatus, searchText } = state;

	function lockUnlock() {
		const id = params.row.quotaId;
		const quota = quotaForApproval.find(item => item.quotaId === id);
		const user = JSON.parse(localStorage.getItem("data"));
		const obj = {
			...quota,
			user,
		};
		console.log("Approval_Quota_LockUnlock", obj);
		dispatch(lockUnlockQuota(obj)).then(() => {
			search();
		});
	}

	function search() {
		dispatch(setState("quotaCustomerBreakdown", null));
		dispatch(setState("quotaDetailsTable", null));
		dispatch(setState("rejectSelectedComment", ''));
		dispatch(setState("selectedRows", []));
		const logedUser = JSON.parse(localStorage.getItem("data"));
		const countryId = selectedCountryID;
		const period = selectedPeriod;
		const quotaStatus = selectedQuotaStatus;

		const obj = {
			countryId,
			period,
			quotaStatus,
			logedUser,
			searchText: searchText
		};
		dispatch(getQuotaForApproval(obj));
	}
	if (isRestrictedAccess) {
		return (
			<IconButton onClick={lockUnlock}>
				{
					params.row.isSubmitLocked ?
						<LockIcon 
						sx={{ 
							color: "black.main" ,
							"&:hover": {
								color: "darkred.light",
								},
						}} /> :
						<LockOpenIcon 
						sx={{ 
							color: "black.main" ,
							"&:hover": {
								color: "darkred.light",
								},
						}} />
				}
			</IconButton>
		);
	}
}

function EditQuota(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const scenarioApprovalState = useSelector((store) => store.quota);
	const { quotaForApproval, countries, selectedRows } = scenarioApprovalState;
	const DefineState = useSelector((store) => store.define);
	const { navigatedCountryId, navigatedScenarioId } = DefineState;

	function gotoEditScenario() {
		const id = params.row.quotaId;
		const quota = quotaForApproval.find((s) => s.quotaId === id);
		const { scenarioName, effectiveStartDate, effectiveEndDate } = quota;
		dispatch(setDefineState("isNavigate", true));
		// #endregion
		navigate("/define/quota");
		let obj = {
			countryID: quota.geoId,
			selectedCountry: countries.find((country) => country.countryID === quota.geoId),
			scenarioID: quota.scenarioId
		}

		// #region Set quota Values
		dispatch(setDefineState("navigatedCountryId", quota.geoId));
		dispatch(setDefineState("navigatedScenarioId", quota.scenarioId));
		dispatch(GetUserCountries({ method: "Get" })).then(() => {
			dispatch(GetScenarioforQuotaDefinition({ method: "GET", countryId: quota.geoId })).then(() => {
				dispatch(GetQuotaPeriodsfromNavigation({ method: "GET", scenarioID: quota.scenarioId })).then(() => {
					dispatch(GetWeeklyDepletion({ method: "GET" })).then(() => {
						dispatch(navigatedValues(obj));
					});
				});
			});
		})

	}

	if (isRestrictedAccess) {
		return (
			<IconButton 
			sx={{
				padding:0,
				'&:hover':{
						 backgroundColor:'#F8E9E7',
						 borderRadius:'2px',
					  }
			 }}
			>
				{
					params.row.isSubmitLocked ?
						"" :
						<EditIcon onClick={gotoEditScenario} 
						sx={{ 
							color: "#000000",
							fontSize:'large', 
							justifyContent: 'center',
							borderRadius:'2px',
							width:25,
							height:22,
							backgroundColor: 'transparent',
							}} />
				}
			</IconButton>
		);
	} else {
		return null;
	}
}

function RevisedQuota(params) {
	const dispatch = useDispatch();
	function removeComma(str) {
		let formattedString = "";
		for (let i = 0; i < str.length; i++) {
			if (str[i] !== ",") {
				formattedString += str[i];
			}
		}
		return formattedString;
	}

	const scenarioApprovalState = useSelector((store) => store.quota);
	const { quotaForApproval, quotaForApprovalTable } = scenarioApprovalState;
	function updateRevisedQuota(event) {
		let RevisedQuota = Number(removeComma(event.target.value));


		if (!RevisedQuota && RevisedQuota !== 0) {
			return;
		}
		let RowTable = JSON.parse(JSON.stringify(quotaForApprovalTable));
		let index = RowTable.rows.findIndex((x) => x.quotaId === params.row.quotaId);
		RowTable.rows[index].revisedQuota = RevisedQuota;
		dispatch(setState("quotaForApprovalTable", RowTable));

		let Row = JSON.parse(JSON.stringify(quotaForApproval));
		let index1 = Row.findIndex((x) => x.quotaId === params.row.quotaId);
		Row[index1].revisedQuota = RevisedQuota;
		dispatch(setState("quotaForApproval", Row));
	}

	return (
		<TextField
			variant="standard"
			value={params.row.revisedQuota?.toLocaleString('en-US')}
			onChange={updateRevisedQuota}
			onClick={(event)=>event.stopPropagation()}
			sx={{ width: 100, textAlign: "center", "& input": { textAlign: "center"} }}
		/>
	);
}